import { Component} from '@angular/core';
import {  Validators } from '@angular/forms';
import { BaseCrudComponent } from "../../base/base-crud.component";
import { CentralNotificacao } from 'app/entity/central-notificacao.model';

@Component({
    selector: 'central-notificacao-crud',
    templateUrl: 'central-notificacao-crud.component.html'
})

export class CrudCentralNotificacaoComponent extends BaseCrudComponent {
    controllerName = 'central-notificacao';
    dados:CentralNotificacao;
    listaSistema:any[] = [];
    listaPerfil:any[] = [];
    listaDiasMes: any[] =[];
    isPerfil: boolean;
    isHideCpf = true;
    listaMeses: any[] = [
    {id: 1, nome: 'Janeiro'},
    {id: 2, nome: 'Fevereiro'},
    {id: 3, nome: 'Março'},
    {id: 4, nome: 'Abril'},
    {id: 5, nome: 'Maio'},
    {id: 6, nome: 'Junho'},
    {id: 7, nome: 'Julho'},
    {id: 8, nome: 'Agosto'},
    {id: 9, nome: 'Setembro'},
    {id: 10, nome: 'Outubro'},
    {id: 11, nome: 'Novembro'},
    {id: 12, nome: 'Dezembro'}];    

    listaDiasSemana: any[] = [
        {id: 1, nome: 'Domingo'},
        {id: 2, nome: 'Segunda'},
        {id: 3, nome: 'Terça'},
        {id: 4, nome: 'Quarta'},
        {id: 5, nome: 'Quinta'},
        {id: 6, nome: 'Sexta'},
        {id: 7, nome: 'Sábado'}];


    init() {
        this.cadastro = this.formBuilder.group({
            etapa1: this.formBuilder.group({
                id_situacao: [1],
                sistema: [null, Validators.required],
                perfil: [null],
                data_especifica:[null, Validators.required],
                dia_semana: [[]],
                tipo_envio: [1, Validators.required],
                dias_mes: [[]],
                mes: [[]],
                cpf: [null],
                url: [null],
                horario: [null, Validators.required],
                descricao: [null, Validators.required],
                tipo_rotina: [1, Validators.required],
                id: [null]
            })
        });

        this.cadastro.get('etapa1.tipo_envio').valueChanges.subscribe(x => {

            switch (Number(x)) {
                case 1:
                    this.isHideCpf = true;
                    this.cadastro.get('etapa1.cpf').clearValidators();
                    this.cadastro.get('etapa1.perfil').setValidators([Validators.required]);
                    this.cadastro.get('etapa1.perfil').updateValueAndValidity();
                    this.cadastro.get('etapa1.cpf').updateValueAndValidity();
                    break;
                case 2:
                    this.isHideCpf = false;
                    this.cadastro.get('etapa1.perfil').clearValidators();
                    this.cadastro.get('etapa1.cpf').setValidators([Validators.required, Validators.minLength(11)]);
                    this.cadastro.get('etapa1.perfil').updateValueAndValidity();
                    this.cadastro.get('etapa1.cpf').updateValueAndValidity();
                    break;
            }
        });

        this.cadastro.get('etapa1.tipo_rotina').valueChanges.subscribe(x => {
            switch (Number(x)) {
                case 1:
                    this.cadastro.get('etapa1.data_especifica').setValidators([Validators.required]);
                    this.cadastro.get('etapa1.dia_semana').clearValidators();
                    this.cadastro.get('etapa1.dia_semana').setValue([]);
                    this.cadastro.get('etapa1.data_especifica').updateValueAndValidity();
                    this.cadastro.get('etapa1.dia_semana').updateValueAndValidity();
                    break;
                case 2:
                    this.cadastro.get('etapa1.data_especifica').clearValidators();
                    this.cadastro.get('etapa1.data_especifica').setValue(null);
                    this.cadastro.get('etapa1.dia_semana').setValidators([Validators.required]);
                    this.cadastro.get('etapa1.data_especifica').updateValueAndValidity();
                    this.cadastro.get('etapa1.dia_semana').updateValueAndValidity();
                    break
                case 3:
                    this.cadastro.get('etapa1.data_especifica').clearValidators();
                    this.cadastro.get('etapa1.data_especifica').updateValueAndValidity();
                    this.cadastro.get('etapa1.dias_mes').setValidators([Validators.required]);
                    this.cadastro.get('etapa1.mes').setValidators([Validators.required]);
                    this.cadastro.get('etapa1.dias_mes').updateValueAndValidity();
                    this.cadastro.get('etapa1.mes').updateValueAndValidity();
                    break;

            }
        });

        this.cadastro.get('etapa1.mes').valueChanges.subscribe(x => {
            this.listaDiasMes = [];
            const date = new Date().getFullYear();
            const mes = +(x[x.length - 1]);

            if(mes || this.cadastro.get('etapa1.mes').value) {
                const ultimoDia = new Date(date, mes, 0).getDate();

                for (let i = 0; i < ultimoDia; i++) {
                    const v = i + 1;
                    this.listaDiasMes.push({id: v, nome: v});
                }
            } else {
                this.listaDiasMes = [];
                this.cadastro.get('etapa1.dias_mes').reset();
            }
        });

        this.service.ListarTodos('sistema').subscribe(data => {
            this.listaSistema = data;
        });
        this.cadastro.get("etapa1.sistema").valueChanges.subscribe(val => {
            if (val != null) {
                this.listaPerfil = [];
                if (this.acao == 'cadastrar')
                    this.service.FiltroPerfil(`perfil/filtrarPerfis`, val).subscribe(retorno => { this.listaPerfil = retorno; });
                else
                this.service.ListarTodos(`perfil`, { sistema: val }).subscribe(retorno => { this.listaPerfil = retorno; });
            }
        });
    }

    afterLoad() {
        let idsSistema:any[] = [];
        this.cadastro.get('etapa1').patchValue(this.obj);

        if (this.obj.central_notificacao_perfil.length){
            this.obj.central_notificacao_perfil.map(x => {
                if(!idsSistema.some(y => y == x.perfil.id_sistema)){
                    idsSistema.push(x.perfil.id_sistema);
                }
            });
            this.isPerfil = true;
            this.cadastro.get('etapa1.tipo_envio').setValue(1);
        } else {
            this.obj.central_notificacao_sistema.map(x => {
                idsSistema.push(x.id_sistema);
            });
            this.isPerfil = false;
            this.cadastro.get('etapa1.tipo_envio').setValue(2);
        }

        const idsPerfil = this.obj.central_notificacao_perfil.map(x => {
            return x.id_perfil;
        });
        const idsDiaSemana = this.obj.central_notificacao_dia_semana.map(x => {
            return x.dia_semana;
        });
        const idMeses = this.obj.central_notificacao_mensal_mes.map(x => {
            return x.mes;
        });
        const idDiasMeses = this.obj.central_notificacao_mensal_dia.map(x => {
            return x.dia;
        });

        this.cadastro.get('etapa1.sistema').setValue(idsSistema);
        this.cadastro.get('etapa1.perfil').setValue(idsPerfil);
        this.cadastro.get('etapa1.dia_semana').setValue(idsDiaSemana);
        this.cadastro.get('etapa1.mes').setValue(idMeses.sort((a, b) => a - b));
        this.cadastro.get('etapa1.dias_mes').setValue(idDiasMeses.sort((a, b) => a - b));
    }

    finalizar(event: any) {

        const limparCpf = this.limpaCaracterEspecial(this.cadastro.get('etapa1.cpf').value);
        this.cadastro.get('etapa1.cpf').patchValue(limparCpf);

        switch (+this.cadastro.get('etapa1.tipo_envio').value) {
            case 1:
                this.cadastro.get('etapa1.cpf').patchValue(null);
            break;
            case 2:
                this.cadastro.get('etapa1.perfil').patchValue(null);
            break;
        }

        this.dados = new CentralNotificacao(this.cadastro.get('etapa1').value,
        this.cadastro.get('etapa1.dia_semana').value,
        this.cadastro.get('etapa1.mes').value,
        this.cadastro.get('etapa1.dias_mes').value,
        this.cadastro.get('etapa1.perfil').value,
        this.cadastro.get('etapa1.sistema').value
)

        this.confirmacao.confirm({
            header: 'Mensagem de Confirmação',
            message: `Atenção! Ao confirmar esta operação, o sistema será ${this.acao == 'cadastrar' ? 'salva' : 'atualizada'} na base de dados.
                Deseja realmente confirmar esta operação?`,
            accept: () => {
                this.observableUtilPanelDoc.setBlockedPanel(true);
                this.acao === 'cadastrar' ?
                    this.service.Adicionar(this.controllerName, this.dados).subscribe(
                        sucess => {
                            sessionStorage.setItem("msg", "Registro salvo com sucesso.");
                            this.router.navigate(['../'], { relativeTo: this.activatedRoute });
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        },
                        err => {
                            this.observableUtilPanelDoc.setBlockedPanel(false)
                            this.showMsg('warn', 'Mensagem de Erro', `Erro ao gravar. ${err._body}`)
                        }) :
                    this.service.Atualizar(this.controllerName, this.dados)
                        .subscribe(
                        sucess => {
                            sessionStorage.setItem("msg", "Registro atualizado com sucesso.");
                            this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        },
                        err => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                            super.showMsg('warn', 'Mensagem de Erro', `Erro ao atualizar. ${err._body}`)
                        });
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/central-notificacao/crud/central-notificacao-crud.component.ts